/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

// For Discount

// Create (POST)
export const createIpBlock = createAsyncThunk('create Ip Block', async (newData) => {
  const response = await $axios.post('/analytics/ip-block', newData);
  return response.data;
});

// Read (GET)
export const fetchIpBlocks = createAsyncThunk('get Ip Block', async () => {
  const response = await $axios.get('/analytics/ip-block');
  return response.data;
});

// // Single data (GET)
// export const fetchSingleData = createAsyncThunk('get single data', async (id) => {
//   const response = await $axios.get(`/gtm/${id}`);
//   return response.data;
// });

// Update (PUT or PATCH)
// export const updateData = createAsyncThunk('update data', async ({ id, updatedData }) => {
//   const response = await $axios.put(`/gtm/${id}`, updatedData);
//   return response.data;
// });

// Delete (DELETE)
// export const deleteData = createAsyncThunk('delete data', async (id) => {
//   await $axios.delete(`/gtm/${id}`);
//   return id;
// });

// export const resetDataDiscountSlice = createAsyncThunk('reset data', async () => {
//   return 'reset data';
// });

// Slice
const analyticsSlice = createSlice({
  name: 'analyticsSlice',
  initialState: {
    // Ip Block state
    ipBlock: [],
    newIpBlock: null,
    newIpBlockError: false,

    // Common
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    // --------------------
    // Ip Block
    // --------------------

    // Create Ip Block
    builder
      .addCase(createIpBlock.pending, (state) => {
        state.newIpBlockError = false;
        state.newIpBlock = null;
        state.loading = true;
      })
      .addCase(createIpBlock.fulfilled, (state, action) => {
        state.loading = false;
        state.newIpBlock = action.payload;
        if (Array.isArray(state.ipBlock)) {
          state.ipBlock.push(action.payload);
        } else {
          state.ipBlock = [action.payload];
        }
      })

      .addCase(createIpBlock.rejected, (state, action) => {
        state.loading = false;
        state.newIpBlock = null;
        state.newIpBlockError = true;
        state.error = action.error.message;
      });

    // Fetch ip block data
    builder
      .addCase(fetchIpBlocks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIpBlocks.fulfilled, (state, action) => {
        state.loading = false;
        state.ipBlock = action.payload;
      })

      .addCase(fetchIpBlocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default analyticsSlice.reducer;
